//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SegmentsNavEditableTab from "./segments-nav-editable-tab";
import ScrollableContainer from "@Shared/components/general/scrollable-container";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsNavbar",
  components: {
    SegmentsNavEditableTab,
    ScrollableContainer
  },
  props: {
    segments: {
      type: Array,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    }
  },
  methods: {
    isCurrentTab(id) {
      return this.currentTab == id;
    },
    handleSegmentAdd() {
      this.$emit("segment-add");
    },
    handleShowTable() {
      this.$emit("show-table");
    },
    handleChangeSegment(id) {
      this.$emit("segment-change", id.toString());
    },
    handleChangeName(val) {
      this.$emit("change-name", val);
    }
  }
});